<template>
  <div class="container">
    <div class="news">
      <div class="news-body">
        <div class="news-body-tab">
          <ul class="news-bt-ul">
            <li
              :class="[`news-bt-li`,tabIndex == i ? `news-bt-li-active`: ``]"
              v-for="(s,i) in tab"
              :key="i"
              @click="changeTab(s,i)"
              ref="tabItem"
            >{{s.title}}</li>
          </ul>
        </div>

        <div class="news-body-view">
          <div class="news-body-centent">
            <!-- 播聘新闻 -->
            <ul class="news-body-item-views" v-show="show">
              <li class="news-body-item-v" v-for="(s,i) in list" :key="i">
                <div class="news-body-item-content">
                  <img src="" alt="">
                  <!-- <div class="news-body-item-v-bg" :style="`background-image: url(${s.img});`"></div> -->
                  <div class="news-body-item-v-title">{{s.title}}</div>
                  <div class="news-body-item-v-sub">
                    <div class="news-body-item-v-sub-from">1来源：{{s.froms}}</div>
                    <div>时间：{{s.date}}</div>
                  </div>
                  <div class="news-body-item-v-content">{{s.content}}</div>
                  <div class="news-body-item-v-more" @click="navgoTo(s)">阅读全文></div>
                </div>
              </li>
            </ul>
            <!-- 播聘新闻 -->

            <!-- 职场资讯 -->
            <ul class="news-body-item-views" v-show="show1">
              <li class="news-body-item-v" v-for="(s,i) in list1" :key="i">
                <div class="news-body-item-content">
                  <div class="news-body-item-v-bg" :style="`background-image: url(${s.img});`"></div>
                  <div class="news-body-item-v-title">{{s.title}}</div>
                  <div class="news-body-item-v-sub">
                    <div class="news-body-item-v-sub-from">2来源：{{s.froms}}</div>
                    <div>时间：{{s.date}}</div>
                  </div>
                  <div class="news-body-item-v-content">{{s.content}}</div>
                  <div class="news-body-item-v-more" @click="navgoTo(s)">阅读全文></div>
                </div>
              </li>
            </ul>
            <!-- 职场资讯 -->

            <!-- 职场故事 -->
            <ul class="news-body-item-views" v-show="show2">
              <li class="news-body-item-v" v-for="(s,i) in list2" :key="i">
                <div class="news-body-item-content">
                  <div class="news-body-item-v-bg" :style="`background-image: url(${s.img});`"></div>
                  <div class="news-body-item-v-title">{{s.title}}</div>
                  <div class="news-body-item-v-sub">
                    <div class="news-body-item-v-sub-from">3来源：{{s.froms}}</div>
                    <div>时间：{{s.date}}</div>
                  </div>
                  <div class="news-body-item-v-content">{{s.content}}</div>
                  <div class="news-body-item-v-more" @click="navgoTo(s)">阅读全文></div>
                </div>
              </li>
            </ul>
            <!-- 职场故事 -->

            <lPages total="990" pageSize="10" :currPage="1"></lPages>
          </div>
          <div>
            <div class="news-body-list">
              <div class="news-body-list-v">
                <h3 class="news-body-list-h3">热门推荐</h3>
                <ul class="news-body-item-view">
                  <li
                    class="news-body-item"
                    v-for="(s,i) in hot"
                    :key="i"
                    @click="navgoTo(s)"
                  >{{s.title}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lPages from "../../components/l-pages/l-pages.vue";
export default {
  components: {
    lPages
  },
  name: "ShowNews",
  data() {
    return {
      show: true, //播聘新闻
      show1: false, //职场资讯
      show2: false, //职场故事
       //播聘新闻
      list: [
        {
          title: "播聘，为人才的价值提供无限可能",
          froms: "播聘",
          date: "2019年9月12日",
           img: ".../../../static/Bitmap_1.png",
          content:
            "受“贸易战”、“行业洗牌”、“生活方式变化”“人力资源成本增加”等因素影响，从2018年下半年开始，我们时常听到裁员、减薪等消息，在经济下行的情况下，许多行业对于员工、岗位的匹配度、精准度、效率等需求越来越强。如何让企业快速招到合适的人才，如何让求职者用最短的时间找到满意的工作，如何降低供需双方在签约入职的过程中所消耗的大量成本，从而提高生产效率。这是很多招聘平台在思考的问题。",
          path: "/show-news-detail"
        },
        {
          title: "一个35岁的职场老鸟给你提个醒：千万不要试图去感动你的领导",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static/Bitmap_2.jpg",
          content:
            "职场上，老板只认“功劳”不认“苦劳”，想用自己的努力去感动老板，真的不可能...",
          path: "/show-message"
        },
           {
          title: "【播聘观察】李克强说的“零工经济”到底是什么？",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static/age.jpg",
          content:
            "在国务院常务会议中，李克强总理强调了推动“分享经济”健康发展的重要性：分享经济利用“互联网+”，不仅创造了很多新业态，化解了不少过剩产能，更带动了大量就业。在雇用模式的转变上，人力市场也出现了“分享经济”的特征，总理随后谈到，他在南方某省考察期间发现，当地出现了改革开放初期曾有过的“零工市场”，工人们没有固定的雇主，而是按小时计算打零工，可能一天内服务好几家雇主。",
          path: "/show-news-ling"
        },
              {
          title: "【播聘观察】企业直播招聘 是因时而变",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static/live.jpg",
          content:
            "随着“75后”占据高管席，“85后”成为中流砥柱，“95后”也逐渐进入职场成为新动能。越来越多的“95后”选择“慢就业”，甚至对按部就班上班失去兴趣。这类心态的出现，给做招聘的HR巨大的压力，HR们开始将招聘主场搬至年轻人群聚集最多的地方，例如直播平台。与此同时，不少企业也玩起了直播招聘。（2月25日 《劳动报》）。",
          path: "/show-live"
        },
                    {
          title: "【播聘观察】直播招聘悄然兴起 拓宽了招聘通道",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static/zhao.png",
          content:
            "最近，武汉某高校影视编导专业的大三学生焦力健，正在为即将到来的求职做准备找实习。和往年奔波在城市各大招聘会有所不同，如今，他和他的师兄师姐们多是在线观看招聘直播。",
          path: "/observe-the"
        },
      ],
      //职场资讯
      list1: [
        {
          title: "95后求职调查：程序员岗位最受青睐",
          froms: "播聘",
          date: "2019年9月15日",
          img: ".../../../static/Bitmap_1.png",
          content:
            "近日，移动社交招聘平台大街网发布《95后求职意愿调查报告》。报告显示，程序员岗位对95后最具吸引力。而在所有互联网企业中，华为（Huawei）、字节跳动（ByteDance）、阿里巴巴（Alibaba）、腾讯（Tencent）组成HBAT格局，占据招聘第一梯队，成为95后最关注和满意度最高的互联网企业",
          path: "/show-news-age"
        }
      ],
       list2: [
         {
          title: "13个高效沟通技巧助你成为HR沟通高手",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static//Bitmap_3.jpg",
          content:
            "高效的沟通技巧是一个HR高手必备的技能，本期播聘工作技巧带你晋级，13个高效沟通技巧干货请收下...",
          path: "/show-acrobatics"
        },
        {
          title: "这十个职场小故事，让我受益一生",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static/Bitmap_4.jpg",
          content:
            "职场是每一个人必然要经历的人生阶段，职场的成功与失败，取决于一个人的知识、能力、经验和素质...",
          path: "/show-story"
        },
        {
          title: "95后求职调查：程序员岗位最受青睐",
          froms: "播聘",
          date: "2019年9月15日",
          img: ".../../../static/age.jpg",
          content:
            "近日，移动社交招聘平台大街网发布《95后求职意愿调查报告》。报告显示，程序员岗位对95后最具吸引力。而在所有互联网企业中，华为（Huawei）、字节跳动（ByteDance）、阿里巴巴（Alibaba）、腾讯（Tencent）组成HBAT格局，占据招聘第一梯队，成为95后最关注和满意度最高的互联网企业",
          path: "/show-news-age"
        }
      ],
     
      tab: [
        {
          title: "全部"
        },
        {
          title: "播聘新闻"
        },
        {
          title: "职场资讯"
        },
        {
          title: "职场故事"
        }
      ],
      tabIndex: 0,
      hot: [
        {
          title: "【播聘新闻 】推动行业高速发展，推动行业高速发展",
          path: "/show-news-detail"
        },
        {
          title:
            "【职场资讯 】一个35岁的职场老鸟给你提个醒：千万不要试图去感动你的领导",
          path: "/show-message"
        },
        {
          title: "【工作技巧 】13个高效沟通技巧助你成为HR沟通高手",
          path: "/show-acrobatics"
        },
        {
          title: "【职场故事 】这十个职场小故事，让我受益一生",
          path: "/show-story"
        }
      ],
      currPage: 5
    };
  },
  methods: {
    changeTab(s, i) {
      console.log(s);
      console.log(i);

      if (i === 2) {
           
        this.show = false;
        this.show1 = true;
        this.show2 = false;
      } else if (i === 1) {
        this.show1 = false;
        this.show2 = false;
        this.show = true;
      } else if (i === 3) {
        this.show = false;
        this.show1 = false;
        this.show2 = true;
      }
      this.tabIndex = i;
      console.log(i);
      // document.documentElement.scrollTop = 495 * (i - 1);
      console.log(document.documentElement.scrollTop);
    },
    navgoTo(s) {
      this.$nav({ path: s.path }, this);
    }
  }
};
</script>

<style scoped="scoped">
@import url("./show-news.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-news/show-news.vue